import axios from 'axios'
import qs from 'qs'
import Element from 'element-ui'
import router from '../router'

// axios.defaults.baseURL = 'https://api.saas.yunrui.net/api/';
// axios.defaults.baseURL = 'http://site.zs.yunrui.net/api/';
// axios.defaults.baseURL = '/api';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 50000;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  const py_token = localStorage.getItem('py_token')
  if (py_token) {
    // 请求头携带token
    config.headers['py-token'] = py_token
  }
  //权限一级php
  let urlAuth = ['release']
  //权限一级python source
  let whitelist = ['need', 'pyadver', 'money', 'user']
  let urlPath = config.url;
  let mediaId = localStorage.getItem("mediaId")
  let urlArr = urlPath.split('/')

  // let whitelist = [
  //   'need/addneed',
  //   'need/editneed',
  //   'need/table',
  //   'need/getAdmins',
  //   'need/needList',
  //   'need/getneed',
  //   'need/addorder',
  //   'need/getorderinfo',
  //   'need/getactionorderinfo',
  //   'need/submitorder',
  //   'need/getdirtree'
  // ]
  var blobList = ['login/getVerify', 'user/exporttemplate', 'user/uploadfiels']
  if (blobList.indexOf(urlPath) != -1) {
    config.responseType = 'blob'
  }

  if (urlPath == 'need/submitorder') {
    config.headers["Content-Type"] = 'multipart/form-data'
  }

  if (whitelist.indexOf(urlArr[0]) != -1) {
    config.baseURL = process.env.VUE_APP_BASE_PYTHON
  } else {
    config.baseURL = process.env.VUE_APP_BASE_API;
  }
  // 在发送请求之前做些什么
  if (config.method == 'post') {
    if (whitelist.indexOf(urlArr[0]) != -1) {
      config.dataSerializer = function (data) {
        return qs.stringify(data, { arrayFormat: "repeat" })
      }
    } else {
      if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
        config.data = {
          mediaId: localStorage.getItem("mediaId"),
          ...config.data
        }
      }
      if (!config.data) {
        config.data = {};
      }
      config.data = qs.stringify(config.data);

    }

  } else if (config.method == 'get') {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" })
    }
    // if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
    if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
      config.params = {
        mediaId: localStorage.getItem("mediaId"),
        ...config.params
      }
    }
  }

  return config;

}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);

});



// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  switch (response.status) {
    case 200:
      return response.data;
    default:
      Element.Message.error([], response.statusText);
  }
}, function (error) {
  // console.log(error)
  // 对响应错误做点什么
  if (error.response.status == 401 || error.response.status == 403) {
    Element.Message.error('登录失效');
    router.replace('/login');
    return Promise.reject(error);
    // return { code: 0 };
  }
});

export default axios;